const initialState = {
    publicPhenomenaGroups: [],
}

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case 'SET_PUBLIC_PHENOMENA_GROUPS_REDUX':
            return {
                ...state,
                publicPhenomenaGroups: payload,
            }
        default:
            return state
    }
} 